module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0107.png.8bfbab5e.jpg";